module.exports = __webpack_public_path__ + "static/img/avatar5.7c2aa2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/avatar5.png
// module id = 100
// module chunks = 2